<!-- SPDX-FileCopyrightText: © 2024 Schneider Electric SPDX-License-Identifier: Apache-2.0 -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M6.31 11.86 3.08 8.63l.71-.71 2.52 2.52 5.9-5.94.71.7z"/></svg>